import React from 'react';
import { IntercomProvider } from 'react-use-intercom';

const prdAppId = 'fjbpflqf'; // Intercom Production Id

const TrevorIntercomProvider: React.FC = ({ children }) => (
  <IntercomProvider appId={prdAppId} autoBoot>
    {children}
  </IntercomProvider>
);

export default TrevorIntercomProvider;
